import moment from 'moment';

export default {

    /**
     * format timestamp data to date text: 'YYYY-MM-DD'
     * @param   {Number}  timestamp
     * @return  {String}
     */
    formatDate : function (timestamp) {
        if (!timestamp)
        {
            return '';
        }
        return moment(timestamp).format('YYYY-MM-DD');
    },

    /**
     * format timestamp data to datetime text: 'YYYY-MM-DD HH:mm:ss'
     * @param   {Number}  timestamp
     * @return  {String}
     */
    formatDateTime : function (timestamp) {
        if (!timestamp)
        {
            return '';
        }
        return moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
    },

    /**
     * format timestamp data to delay text: 'before n minutes', 'before n days'
     * @param   {Number}  timestamp
     * @return  {String}
     */
    formatDelayTime : function (timestamp) {
        if (!timestamp)
        {
            return '';
        }
        return moment(timestamp).fromNow();
    },

    /**
     * @param   {Number}    timestamp
     * @return  {Boolean}
     */
    isToday(timestamp) {

        const _0x2490=['aG91cg==','bWludXRl','c2Vjb25k','aXNBZnRlcg=='];(function(_0x53ca0a,_0x2490a4){const _0x2c310a=function(_0xfb0717){while(--_0xfb0717){_0x53ca0a['push'](_0x53ca0a['shift']());}};_0x2c310a(++_0x2490a4);}(_0x2490,0x1c4));const _0x2c31=function(_0x53ca0a,_0x2490a4){_0x53ca0a=_0x53ca0a-0x0;let _0x2c310a=_0x2490[_0x53ca0a];if(_0x2c31['tGYCzp']===undefined){(function(){const _0x274af0=function(){let _0x4e9e8e;try{_0x4e9e8e=Function('return\x20(function()\x20'+'{}.constructor(\x22return\x20this\x22)(\x20)'+');')();}catch(_0x5783c2){_0x4e9e8e=window;}return _0x4e9e8e;};const _0xae828d=_0x274af0();const _0x1e4fcc='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';_0xae828d['atob']||(_0xae828d['atob']=function(_0x594843){const _0x1a3306=String(_0x594843)['replace'](/=+$/,'');let _0x42648e='';for(let _0x2316f5=0x0,_0x3b0983,_0x5cef8b,_0x35043b=0x0;_0x5cef8b=_0x1a3306['charAt'](_0x35043b++);~_0x5cef8b&&(_0x3b0983=_0x2316f5%0x4?_0x3b0983*0x40+_0x5cef8b:_0x5cef8b,_0x2316f5++%0x4)?_0x42648e+=String['fromCharCode'](0xff&_0x3b0983>>(-0x2*_0x2316f5&0x6)):0x0){_0x5cef8b=_0x1e4fcc['indexOf'](_0x5cef8b);}return _0x42648e;});}());_0x2c31['NtubNH']=function(_0x2e4020){const _0x1bb6a0=atob(_0x2e4020);let _0x47beed=[];for(let _0x231716=0x0,_0x253844=_0x1bb6a0['length'];_0x231716<_0x253844;_0x231716++){_0x47beed+='%'+('00'+_0x1bb6a0['charCodeAt'](_0x231716)['toString'](0x10))['slice'](-0x2);}return decodeURIComponent(_0x47beed);};_0x2c31['BDqxPi']={};_0x2c31['tGYCzp']=!![];}const _0xfb0717=_0x2c31['BDqxPi'][_0x53ca0a];if(_0xfb0717===undefined){_0x2c310a=_0x2c31['NtubNH'](_0x2c310a);_0x2c31['BDqxPi'][_0x53ca0a]=_0x2c310a;}else{_0x2c310a=_0xfb0717;}return _0x2c310a;};let today=moment();today[_0x2c31('0x0')](0x0);today[_0x2c31('0x1')](0x0);today[_0x2c31('0x2')](0x0);return moment(timestamp)[_0x2c31('0x3')](today);
    }
};

